// 📁 config/integrationsConfig.js
//
// Hardware integrations that Zezamii Access syncs with. Same shape as
// productsConfig.js — consumed by ModuleGridPage to render the cards grid.
//
// To add a 4th integration (Inception, Kisi, Salto, etc.):
//   1. Create/reuse the DefaultSetting row in DB for the module flag.
//   2. Add the constant to constants/settings.js.
//   3. Add an entry here with its logo + description.
//   4. Add an entry to SETTING_GROUP_IDS if the integration has its own
//      settings tab.

import { SETTING_GROUP_IDS } from './settingsMenuConfig';
import { CONSTANTS_SETTINGS } from './settingsContainer';
import { LogoControlApp, LogoIntegrityApp, LogoTTLockApp } from 'assets/images/svg/Logos';

/**
 * @typedef {Object} IntegrationConfig
 * @property {string|number} key           - SettingGroup ID (also the selectedSettingGroupID when clicked)
 * @property {string}        label         - Display name
 * @property {string}        description   - Card pitch
 * @property {string}        logo          - Image asset
 * @property {number}        moduleFlag    - DefaultSettingID of the module toggle
 */

/** @type {IntegrationConfig[]} */
export const INTEGRATIONS = [
	{
		key: SETTING_GROUP_IDS.CONTROL,
		label: 'Control',
		description:
			'Smart lock platform. Sync locks, cards, passcodes, and access logs — unlock via gateway, Bluetooth, or mobile app from anywhere.',
		logo: <LogoControlApp />,
		moduleFlag: CONSTANTS_SETTINGS.CONTROL_MODULE
	},
	{
		key: SETTING_GROUP_IDS.INNER_RANGE,
		label: 'Inner Range',
		description:
			'Enterprise-grade access control for doors, lifts, and permission groups. Full bidirectional sync with Integriti — users, credentials, and permissions stay aligned across both systems.',
		logo: <LogoIntegrityApp />,
		moduleFlag: CONSTANTS_SETTINGS.INNER_RANGE_MODULE
	},
	{
		key: SETTING_GROUP_IDS.TTLOCK,
		label: 'TTLock',
		description:
			'Smart lock platform. Sync locks, eKeys, passcodes, cards, and access logs — unlock via gateway, Bluetooth, or mobile app from anywhere.',
		logo: <LogoTTLockApp />,
		moduleFlag: CONSTANTS_SETTINGS.TTLOCK_MODULE
	}
];

// Integrations can all be off simultaneously — Access still works with
// Zezamii-native devices. No minimum.
export const MIN_ACTIVE_INTEGRATIONS = 0;
